import InstantPlay from './InstantPlay';
import React from 'react';
import { connect } from 'react-redux';
import orderBy from 'lodash/fp/orderBy';
import { buildInstantPlayGames, Status } from '../stolen-from-widget';
import { Typography, Divider, Tag } from '@nackle/origami';
import './InstantPlayList.less';
import { Translate } from '@nackle/arcade-core-v2';
import CypherService from '../../services/cypher-services';
import { ARCADE_PROJECT_STENCIL, ROOM_NAME_KEY } from '../../utils/constants';
import translationCache from '../../utils/cache';
import CenteredSpinner from '../../components/CenteredSpinner';
const { Title } = Typography;

const mapStateToProps = () => {
    const getInstantPlayGames = buildInstantPlayGames();

    return ( state ) => {
        return {
            plays: getInstantPlayGames( state ),
        };
    };
};

class InstantPlays extends React.Component {
   state = {
    roomMap: {},
  }; 
  unsubscribeTranslationCache = null;
  roomNamesLoaded = false;

   async componentDidMount() {
    this.unsubscribeTranslationCache = translationCache.subscribe( () => {
      this.forceUpdate();
    } );
     await this.loadRoomNames();
  }
    async componentDidUpdate( prevProps ) {
    if (
        prevProps.plays !== this.props.plays &&
        Array.isArray( this.props.plays )
    ) {
        await this.loadRoomNames();
    }
}

   componentWillUnmount() {
    if ( this.unsubscribeTranslationCache ) {
      this.unsubscribeTranslationCache();
    }
  }

  
   loadRoomNames = async () => {
    const { plays, user, locale } = this.props;

    if ( !Array.isArray( plays ) || plays.length === 0 ) {
      return;
    }
    const roomIds = [ ...new Set( plays.map( ( play ) => play.roomId ) ) ];

    try {
      const cypher = CypherService( user );
      const result = await cypher.getStencilInstancesByCodesAndLocales(
        ARCADE_PROJECT_STENCIL,
        locale,
        roomIds
      );

      const roomMap = Object.entries( result.stencils || {} ).reduce(
        ( acc, [ roomId, roomData ] ) => {
          acc[ roomId ] = roomData?.[ locale ]?.[ ROOM_NAME_KEY ] || '';
          return acc;
        },
        {}
      );
      this.setState( { roomMap } );
    } catch ( error ) {
      console.error( error );
    }
  };
  render() {
    const { plays } = this.props;
    const { roomMap } = this.state;

    if ( plays === Status.LOADING ) {
       return (
        <CenteredSpinner />
    );
    }
    if ( plays === Status.ERROR ) {
      return <div>error</div>;
    }

    if ( plays.length === 0 ) {
      return null;
    }

    const orderedPlays = orderBy( [ 'playCount' ], [ 'desc' ] )( plays );

    return (
      <div className="instant-play-list">
        { orderedPlays.map( ( play ) => {
          const romId = play.cabinet.romId;
          return (
            <React.Fragment key={ play.cabinet.cabinetId }>
              <div className="instant-header">
                <div className="divider">
                  <Divider />
                </div>
                <div className="instant-header-text">
                  <Title level={ 2 } strong>
                    <span>
                       { roomMap[ play.roomId ] }
                    </span>
                  </Title>

                  <div className="instant-tag">
                    <Tag.Color size="medium" status="processing">
                      { play.playCount === 1 ? <>{ play.playCount } <Translate id={ 'arcade.webapp.instantPlay' } /> </> : 
                      <>{ play.playCount } <Translate id={ 'floor.INSTANT.PLAYS.HEADER' } /> </> }
                    </Tag.Color>
                  </div>
                </div>
              </div>

              <InstantPlay
                cabinet={ play.cabinet }
                onClick={ this.props.onClickCabinet }
                playCount={ play.playCount }
                roomId={ play.roomId }
                romId={ romId }
                isUmbrella={ this.props.isUmbrella }
              />
            </React.Fragment>
          );
        } ) }
      </div>
    );
  }
} 
export default connect( mapStateToProps )( InstantPlays );
